import React from 'react';
import { IconProps } from './types';

export const ProfileIcon = (props: IconProps) => {
  const { size = 16, color = 'currentColor', style = {} } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
    >
      <path
        fill={color}
        d='M12 13.9c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zm0-10c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zM12 23c-4.4 0-8.9-1.4-8.9-4.2 0-2.8 4.5-4.2 8.9-4.2s8.9 1.4 8.9 4.2c0 2.8-4.5 4.2-8.9 4.2zm0-6.4c-4.3 0-6.9 1.4-6.9 2.2 0 .8 2.6 2.2 6.9 2.2 4.3 0 6.9-1.4 6.9-2.2 0-.8-2.6-2.2-6.9-2.2z'
      />
    </svg>
  );
};
